import React from 'react';
import styles from './AdminMobileSelect.module.css';
import Center from 'layouts/wrapper/Center';

const AdminMobileSelect = ({ options, onChange }) => {
    const handleSelectChange = (event) => {
        onChange(event.target.value);
    };

    return (
        <Center>
            <select className={styles.select} onChange={handleSelectChange}>
                {options.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                    ))}
            </select>
        </Center>
    );
};

export default AdminMobileSelect;